export default __webpack_public_path__ + "static/iipc_logo-60d4e692b9c19cd8f66070619d57b5a4.png";